module.exports = __webpack_public_path__ + "img/success-icon.8fed09ac.png";